import React, { useEffect, useState } from "react";
import { SmartCaptcha } from "@yandex/smart-captcha";
import styled from "styled-components";

const CaptchaContainer = styled.div`
  position: relative;
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f4f4f4;
`;

const CaptchaBox = styled.div`
  width: 90%;
  max-width: 320px;
  padding: 24px;
  background-color: white;
  border-radius: 16px;
`;

const IconButton = styled.div`
  position: absolute;
  top: 10px;
  left: 15px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BackIconButton = ({ handleClick }) => {
  return (
    <IconButton onClick={handleClick} id="back-button">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.75 5C8.75 7.71744 7.64916 10.2288 5.89258 11.75H22V13.25H5.89258C7.64916 14.7712 8.75 17.2826 8.75 20H7.25C7.25 16.1061 4.75286 13.25 2 13.25V11.75L2.25684 11.7412C4.90623 11.5703 7.25 8.77236 7.25 5H8.75Z"
          fill="#212223"
        />
      </svg>
    </IconButton>
  );
};

const EVENT_TYPES = {
  LOADED: "captchaLoaded",
  CLOSE: "captchaClose",
  SUCCESS: "captchaSuccess",
  CHALLENGE_VISIBLE: "captchaChallengeVisible"
};

const postToWebView = data => {
  window.ReactNativeWebView?.postMessage(JSON.stringify(data));
};

export const YandexCaptchaWebView = () => {
  const [resetCaptcha, setResetCaptcha] = useState(0);

  useEffect(() => {
    postToWebView({ type: EVENT_TYPES.LOADED });
  }, []);

  const handleSuccess = captchaToken => {
    postToWebView({ type: EVENT_TYPES.SUCCESS, token: captchaToken });
  };

  const handleChallengeVisible = () => {
    postToWebView({ type: EVENT_TYPES.CHALLENGE_VISIBLE, value: true });
  };

  const handleChallengeHidden = () => {
    postToWebView({ type: EVENT_TYPES.CHALLENGE_VISIBLE, value: false });
  };

  const handleCloseCaptcha = () => {
    postToWebView({ type: EVENT_TYPES.CLOSE });
  };

  const handleTokenExpired = () => {
    setResetCaptcha(prev => prev + 1);
  };

  return (
    <CaptchaContainer>
      <BackIconButton handleClick={handleCloseCaptcha} />
      <CaptchaBox>
        <SmartCaptcha
          key={resetCaptcha}
          sitekey="ysc1_lEYLoLW5qP08Jreg0ZY3JGMjFAafeZJqp5BJKlgre3a94e54"
          webview
          onSuccess={handleSuccess}
          onChallengeVisible={handleChallengeVisible}
          onChallengeHidden={handleChallengeHidden}
          onTokenExpired={handleTokenExpired}
        />
      </CaptchaBox>
    </CaptchaContainer>
  );
};
